import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';
import insertInArrayIf from '@zola-helpers/client/dist/es/util/insertInArrayIf';
import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import { PrimaryNavMenu } from './types';

const {
  PRIMARY: { ACCOUNT },
} = NAV_DATA;

const getAccount = ({
  userContext = {},
  isPostAuthNav3Enabled = false, // Clean up with experiment
}: {
  userContext?: UserContext;
  isPostAuthNav3Enabled?: boolean;
}): PrimaryNavMenu => {
  const hasWeddingAccount = Boolean(userContext.has_wedding_account);
  const hasRegistry = Boolean(userContext.has_registry);

  const children = [
    {
      title: isPostAuthNav3Enabled ? 'Your account' : 'Your Account',
      path: '/account/settings/info',
    },
    {
      title: isPostAuthNav3Enabled ? 'Your wedding details' : 'Your Wedding Details',
      path: '/account/settings/wedding',
    },
    {
      title: isPostAuthNav3Enabled ? "Orders you've placed" : "Orders You've Placed",
      path: '/account/settings/orders',
    },
    {
      title: isPostAuthNav3Enabled ? 'Ratings and reviews' : 'Ratings and Reviews',
      path: '/account/settings/reviews',
    },
    {
      title: isPostAuthNav3Enabled ? 'Zola store credit' : 'Zola Store Credit',
      path: '/account/settings/credits',
    },
    ...insertInArrayIf(hasRegistry || hasWeddingAccount, {
      title: isPostAuthNav3Enabled ? 'Privacy settings' : 'Privacy Settings',
      path: '/account/settings/privacy',
    }),
    {
      title: isPostAuthNav3Enabled ? 'Invite friends' : 'Invite Friends',
      path: '/wedding-registry/invite',
    },
  ];

  return {
    title: 'Account',
    id: ACCOUNT,
    path: '/account/settings/info',
    parent: 'Account',
    children,
  };
};

export default getAccount;
